import { apiDelete } from "../baseApi";

export const deleteForInvite = async (id,data={}, cancelToken = null) => {
  try {
    const response = await apiDelete("_userDeleteInvite", id, data, { cancelToken });
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
